import React from 'react';
//import { Document, Page } from "react-pdf/dist/entry.webpack";
//import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import pdf_c100 from './docs/c100.pdf'

import * as net from "../lib/net";
import LoginDlg from "./dlg/login_dlg";
import {withRouter} from "../lib/react/withRouter";

function web01() {

    var html =
    <div className="web-content">
    </div>
    ;
    return html;
}

class Web_Adm extends React.Component {
    //var sdo = useContext(SDO);
    constructor(props, context) {
        super(props);

        this.webStore = props.store;
        this.state = { pgid: 11, stat: [] };
        this.state.open = false;
        this.state.pdfopen = false;
        this.state.xxopen = false;
        this.state.pdf_uri = "";
        this.state.seldate = new Date('2020-03-24T13:11:54');
        this.state.row = null;
        this.state.pageNumber = 1;
        this.state.numPages = null;
        this.state.login = false;
        //context.posrend = this;
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }
   row_css(row) {
  	    var css = {};
		if(this.state.row) {
		if(this.state.row.ank == row.ank) {
			css.background = "#080";
			css.color = "#fff";
		}
		}
		return css;
    }
    login() {
        this.setState({login: true });
        //this.props.history.push("pos");
    }
    dologin(uid, pwd) {
        this.setState({login: false });
        //this.props.history.push("cas");
        this.login_srv(uid, pwd);
    }
    login_srv(uid, pwd) {
        var self = this;
		var prm = {};
		prm.uid = uid;
		prm.pwd = pwd;
		prm.token = "";

        //gda.wndLoading("Hämtar");
        net.gcs_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret));

            var o = {};
            //o.deps = ret.rco;
            //alert(JSON.stringify(o));
            //self.setState({tra: ret.rca });
            //toastr.success("OK", "SAPI");
            if(ret.ok != "000") {
                alert(JSON.stringify(ret));
                return;
            }

            var seo = ret.seo;
            alert(JSON.stringify(seo));
            //alert(JSON.stringify(seo.auto));
            self.props.navigate("cas");
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
            alert(JSON.stringify(e));
            //gda.wndError(txt);
        });
    }
    render() {
        const { pageNumber, numPages } = this.state;
        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
        const handleDateChange = date => {
            this.setState({seldate: date });
        };

        return (
            <div className="web-app">
            <div className="web-title flex-row flex-space-between">
                <h6 style={{ padding:"5px 10px" }}>SVERIGEKASSAN</h6>
                <button className="btn btn-hw-blue w150 ripple" onClick={() => this.login() } aria-label="System" >
                    Logga in
                </button>
            </div>

            <div className="web-body">
            <div className="flex-row">
            <div className="flex" style={{background:"#ccc"}}>
            </div>
            <div className="flex flex-col">
            </div>
            <div className="flex" style={{background:"#ccc"}}>
            </div>
            </div>
            </div>
            <LoginDlg show={this.state.login} ctx={this} backdrop={true}/>
           </div>
        );
    }

}
//Sys.contextType = ADOContext;

export default withRouter(Web_Adm);

/*
                <Document
                  file={ pdf_c100 }
                  onLoadSuccess={this.onDocumentLoadSuccess}
                >
                  <Page pageNumber={ pageNumber } width={700} />
                </Document>
                <Document
                  file={ pdf_c100 }
                  onLoadSuccess={this.onDocumentLoadSuccess}
                >
                  <Page pageNumber={ 2 } width={700} />
                </Document>

 */